import React from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useField } from 'formik';

const InputRadio = (props) => {

    const [field, meta, helper] = useField(props);

    return (
        <Form.Group controlId={`form-${props.name}`}>
            <Form.Label>{props.label}</Form.Label>
            <InputGroup hasValidation>
                <InputGroup.Radio name={`check-${props.name}`} checked={props.checked || false} onChange={props.onFocus ? props.onFocus : () => {}} />
                <Form.Control
                    type="text"
                    placeholder=""
                    aria-describedby="inputGroupPrepend"
                    name={props.name}
                    value={field.value}
                    onChange={(e) => {
                        helper.setValue(e.target.value.toString().toUpperCase(), true);
                        helper.setTouched(true);
                    }}
                    isValid={field.value !== '' && !meta.error && meta.touched}
                    isInvalid={!!meta.error}
                    {...props}
                />
                <Form.Control.Feedback type="invalid"> {meta.error} </Form.Control.Feedback>
            </InputGroup>

        </Form.Group>
    );

}

export default InputRadio;